import { cn } from '@sohanemon/utils';
import { m } from '@sohanscript/i18n';
import { TextRotate } from '@sohanscript/ui/rotate-text';
import { SohanscriptLogo } from '@sohanscript/ui/sohanscript-logo';
import { Link } from '@/components/link';
import { getUrl } from '@/lib/utils/app-env';

interface BrandProps {
	className?: string;
	full?: boolean;
	noAnim?: boolean;
	mini?: boolean;
}

const BRAND_WORDS = [
	{ pattern: /oneman/, word: 'Preview' },
	{ pattern: /sohancodes/, word: 'Codes' },
	{ pattern: /sohanworks/, word: 'Works' },
	{ pattern: /sohanships/, word: 'Ships' },
	{ pattern: /sohanbuilds/, word: 'Builds' },
	{ pattern: /sohanwrites|sohan-writes/, word: 'Writes' },
	{ pattern: /sohan-notes/, word: 'Notes' },
	{ pattern: /sohanjs/, word: 'JS' },
	{ pattern: /sohanemon/, word: 'Emon' },
] as const;

const ALL_WORDS = [
	'Script',
	'JS',
	'Emon',
	'Codes',
	'Works',
	'Writes',
	'Ships',
	'Builds',
	'Notes',
];

function getBrandWord(url = getUrl()): string {
	return BRAND_WORDS.find((e) => e.pattern.test(url))?.word ?? 'Script';
}

export function Brand({ className, noAnim, full, mini }: BrandProps) {
	const brandWord = getBrandWord();
	const texts = [brandWord, ...ALL_WORDS.filter((w) => w !== brandWord)];

	return (
		<Link
			to="/"
			hash="top"
			aria-label={m.brand_go_home()}
			className={cn(
				'group/brand inline-flex origin-left items-end text-center font-black font-sans text-muted/60 leading-4 max-sm:scale-75',
				mini && 'items-center leading-none',
				className,
			)}
		>
			<SohanscriptLogo className={cn('h-11', mini && 'h-5')} />

			{!mini && (
				<h2
					className={cn(
						'h-5 w-fit text-primary',
						'font-matrix text-sm',
						'flex items-center',
						!full &&
							'scale-x-0 align-bottom font-bold leading-normal opacity-0 transition-all duration-400 ease-out group-hover/brand:translate-x-0 group-hover/brand:scale-x-100 group-hover/brand:opacity-100',
						!full &&
							'origin-top-left -translate-x-7 rtl:origin-top-right rtl:translate-x-7',
					)}
				>
					Sohan
					{noAnim ? (
						brandWord
					) : (
						<TextRotate className="brightness-70" texts={texts} />
					)}
				</h2>
			)}
		</Link>
	);
}
